import PlanoAcaoHandler from "@components/Handlers/PlanoAcaoHandler/Index";
import RelatorioHandler from "@components/Handlers/RelatorioHandler/Index";
import { FormularioOptionProcessoModal } from "@components/Modals/Admin/FormularioOptionProcessoModal/Index";
import ButtonComp from "@components/UI/Button/Index";
import RenderIfStatusAndRole from "@components/UI/RenderIfStatusAndRole/Index";
import { useSolicitacaoSubmitHandlers } from "@hooks/functions/Solicitacao/Admin/useSolicitacaoSubmitHandlers";
import { perfisAdmin } from "@utils/auth/perfis";

function ButtonActionsSection({
    methods,
    solicitacaoFields,
    relatorios,
    planosAcao,
    solicitacaoProcessoItems
}) {

    const {
        onUpdate,
        onSubmitRequest,
        onSubmitReport,
        onFinishRequest
    } = useSolicitacaoSubmitHandlers({
        solicitacaoFields,
        solicitacaoProcessoItems
    });

    return (

        <div className="row mt-4">
            <div className="col-12 col-md-12">
                <div className="block h-auto">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="d-flex justify-content-center gap-2">

                                    {/* ANEXAR E VISUALIZAR FORMULÁRIOS DO PROCESSO */}
                                    <FormularioOptionProcessoModal
                                        idProcesso={solicitacaoFields?.compliance?.idProcesso}
                                        idSolicitacao={solicitacaoFields?.id}
                                        formularioModeloInicial={solicitacaoFields?.formularioAssociadoProcesso}
                                        formularioRespostaInicial={solicitacaoFields?.formularioRespostaProcesso}
                                    />

                                    <form onSubmit={methods.handleSubmit(onUpdate)} noValidate>
                                        <div className="d-flex justify-content-center gap-2">
                                            {/* ATUALIZAR A SOLICITAÇÃO */}
                                            <RenderIfStatusAndRole
                                                idSolicitacao={solicitacaoFields?.id}
                                                allowedStatuses={[1, 2, 3, 4]}
                                                allowedRoles={perfisAdmin}
                                            >
                                                <ButtonComp
                                                    title={"ATUALIZAR"}
                                                    type={"submit"}
                                                    buttonColor={"#2b97be"}
                                                    classnameIcon={"fa-regular fa-floppy-disk"}
                                                    hoverMessage={"Botão para atualizar a solicitação"}
                                                />
                                            </RenderIfStatusAndRole>

                                            {/* ENVIO DA SOLICITAÇÃO */}
                                            <RenderIfStatusAndRole
                                                idSolicitacao={solicitacaoFields?.id}
                                                allowedStatuses={[1]}
                                                allowedRoles={perfisAdmin}
                                            >
                                                <ButtonComp
                                                    title={"ENVIAR"}
                                                    type={"button"}
                                                    onClick={onSubmitRequest}
                                                    buttonColor={"#125578"}
                                                    classnameIcon={"fa-solid fa-check"}
                                                    hoverMessage={"Botão para enviar a solicitação"}
                                                />
                                            </RenderIfStatusAndRole>

                                            {/* RELATÓRIOS */}
                                            <RelatorioHandler
                                                idSolicitacao={solicitacaoFields?.id}
                                                idProcesso={solicitacaoFields?.compliance?.idProcesso}
                                                idUnidadeGerencia={solicitacaoFields?.unidadeGerencia?.id}
                                                codigoProcesso={solicitacaoFields?.compliance?.codigoProcesso}
                                                flagAuditoria={solicitacaoFields?.compliance?.flagAuditoria}
                                                relatoriosExistentes={relatorios}
                                            />

                                            {/* ENVIO DO RELATÓRIO */}
                                            <RenderIfStatusAndRole
                                                idSolicitacao={solicitacaoFields?.id}
                                                allowedStatuses={[4]}
                                                allowedRoles={perfisAdmin}
                                                flagAuditoria={solicitacaoFields?.compliance?.flagAuditoria}
                                                onlyIfAuditoria={true}
                                            >
                                                <ButtonComp
                                                    title={"ENVIAR RELATÓRIO"}
                                                    buttonColor={"#2b97be"}
                                                    type={"button"}
                                                    onClick={onSubmitReport}
                                                    classnameIcon={"fa-regular fa-floppy-disk"}
                                                    hoverMessage={"Botão para enviar o relatório"}
                                                />
                                            </RenderIfStatusAndRole>

                                            {/* VISUALIZAR PLANO DE AÇÃO */}
                                            <PlanoAcaoHandler
                                                idSolicitacao={solicitacaoFields?.id}
                                                idProcesso={solicitacaoFields?.compliance?.idProcesso}
                                                idUnidadeGerencia={solicitacaoFields?.unidadeGerencia?.id}
                                                codigoProcesso={solicitacaoFields?.compliance?.codigoProcesso}
                                                flagAuditoria={solicitacaoFields?.compliance?.flagAuditoria}
                                                planosAcaoExistentes={planosAcao}
                                            />
                                                
                                            <RenderIfStatusAndRole
                                                idSolicitacao={solicitacaoFields?.id}
                                                allowedStatuses={[1, 2, 3, 4, 5, 6]}
                                                allowedRoles={perfisAdmin}
                                            >
                                                {/* ENCERRAR A SOLICITAÇÃO */}
                                                <ButtonComp
                                                    title={"ENCERRAR"}
                                                    buttonColor={"#B23B3B"}
                                                    type={"button"}
                                                    onClick={onFinishRequest}
                                                    classnameIcon={"fa-regular fa-circle-xmark"}
                                                    hoverMessage={"Botão para encerrar a solicitação"}
                                                />
                                            </RenderIfStatusAndRole>
                                        </div>
                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default ButtonActionsSection;